/**
 * Bitácora de auditoría sobre Supabase (entity="audit_log" en pmis_entities).
 * Append-only: solo create + list/get.
 */

import type { AuditLogRepo, NuevaAuditEntry } from "../../repos/AuditLogRepo";
import type { AuditEntry } from "@app-types/entities";
import { SupabaseBaseRepo } from "./SupabaseBaseRepo";

export class SupabaseAuditLogRepo
  extends SupabaseBaseRepo<AuditEntry>
  implements AuditLogRepo
{
  constructor(tenantId: string) {
    super("audit_log", tenantId);
  }

  async list(filter?: {
    usuario?: string;
    accion?: string;
    entidad?: string;
    entidadId?: string;
    desde?: string;
    hasta?: string;
  }): Promise<AuditEntry[]> {
    let rows = await this.listAll();
    if (filter?.usuario) rows = rows.filter((r) => r.usuario === filter.usuario);
    if (filter?.accion) rows = rows.filter((r) => r.accion === filter.accion);
    if (filter?.entidad) rows = rows.filter((r) => r.entidad === filter.entidad);
    if (filter?.entidadId) rows = rows.filter((r) => r.entidadId === filter.entidadId);
    if (filter?.desde) rows = rows.filter((r) => r.timestamp >= filter.desde!);
    if (filter?.hasta) rows = rows.filter((r) => r.timestamp <= filter.hasta!);
    return rows.sort((a, b) => b.timestamp.localeCompare(a.timestamp));
  }

  async get(id: string): Promise<AuditEntry | null> {
    return this.getById(id);
  }

  async create(data: NuevaAuditEntry): Promise<string> {
    const entry: AuditEntry = {
      ...data,
      id: crypto.randomUUID(),
      tenantId: this.tenantId,
      createdAt: data.timestamp,
      updatedAt: data.timestamp,
      createdBy: data.usuario,
      updatedBy: data.usuario,
      version: 1,
    };
    await this.createRaw(entry);
    return entry.id;
  }
}
